import React from 'react';
import { Box, Stack, Typography } from '@mui/joy';
import DatePicker from 'react-datepicker';
import ScheduleIcon from '@mui/icons-material/Schedule';

const CustomTimeInput = React.forwardRef<HTMLInputElement, any>(
  ({ value, onClick, placeholder }, ref) => (
    <input
      type="text"
      onClick={onClick}
      ref={ref}
      value={value}
      placeholder={placeholder}
      readOnly
      style={{ cursor: 'pointer', width: '100%', height: 52, borderRadius: 12, backgroundColor: '#edeff3', border: 'none', outline: 'none', fontSize: 16, paddingLeft: 16, paddingRight: 40 }}
    />
  )
);

interface MeetingTimeWindowProps {
  startTime: Date;
  endTime: Date;
  onStartChange: (date: Date) => void;
  onEndChange: (date: Date) => void;
  error?: string;
}

const MeetingTimeWindow: React.FC<MeetingTimeWindowProps> = ({ startTime, endTime, onStartChange, onEndChange, error }) => (
  <Box mb={2}>
    <Typography level="body-sm" mb={1}>Time Window</Typography>
    <Stack direction="row" spacing={2}>
      <Box sx={{ position: 'relative', flex: 1 }}>
        <DatePicker
          selected={startTime}
          onChange={(date) => date && onStartChange(date)}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          timeCaption="Start"
          dateFormat="h:mm aa"
          customInput={<CustomTimeInput placeholder="Start time" />}
          popperPlacement="bottom-start"
        />
        <Box sx={{ position: 'absolute', top: '50%', right: 16, transform: 'translateY(-50%)', pointerEvents: 'none' }}>
          <ScheduleIcon sx={{ width: 24, height: 24 }} />
        </Box>
      </Box>
      <Typography level="body-sm" sx={{ alignSelf: 'center' }}>to</Typography>
      <Box sx={{ position: 'relative', flex: 1 }}>
        <DatePicker
          selected={endTime}
          onChange={(date) => date && onEndChange(date)}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          timeCaption="End"
          dateFormat="h:mm aa"
          customInput={<CustomTimeInput placeholder="End time" />}
          popperPlacement="bottom-start"
        />
        <Box sx={{ position: 'absolute', top: '50%', right: 16, transform: 'translateY(-50%)', pointerEvents: 'none' }}>
          <ScheduleIcon sx={{ width: 24, height: 24 }} />
        </Box>
      </Box>
    </Stack>
    {error && (
      <Typography color="danger" level="body-xs" mt={1}>{error}</Typography>
    )}
  </Box>
);

export default MeetingTimeWindow; 